import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = '[data-choose-form]';
const PLUGIN_NAME = 'chooseForm';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "choose-form" */ './choose-form'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/choose-form/index--split.js